<template>
    <div>
        <dictionary-simple-table
        dictionary_link = "/product-colors"
        title = "Lista kolorów"
        :numeral_text = "['kolor', 'kolory', 'kolorów']"
        :columns_title = "['name']"
        ></dictionary-simple-table>
    </div>
</template>

<script>
    import DictionarySimpleTable from './DictionarySimpleTable.vue';
    export default {
        components: {
            DictionarySimpleTable
        },
    }
</script>